import React, { useState, useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { inject, observer } from 'mobx-react';
import { Button, Input, Form, TextArea, Selector, Dialog, SpinLoading, DotLoading } from 'antd-mobile';
import ToastUtils from '@/utils/ToastUtils';
import PullRefreshList from '@/components/Mobile/PullRefreshList';
import { Display } from '@/components/Display/Display';
import withRouter from '@/components/withRouter';
import ModalPopup from '@/components/Mobile/ModalPopup/ModalPopup';
import { cloneDeep } from 'lodash';
import ServiceUpload from '@/components/ServiceUpload';
import Utils, { getPrivateOrPublic, getCourseEditingUploadType, UploadType, formatDate } from '@/components/Utils';
import { handleCreate, handleGetTransInfoList, handleUpdateTitle, handleDelete, handleGetTransList, handleRetryTrans } from '@/api/tingWu';
import { languageOptionsSearch, sourceLanguageOptions, speakerOptions } from './dict';
import s from './index.module.scss';
import emptyImg from '@/assets/images/mobile/empty.webp';
import { Storage } from '@/utils/Storage';
import { fetchCheckCanRecord } from '@/api/tingWu';
import { LeftOutline, CheckOutline } from 'antd-mobile-icons';
import GrtLoading from '@/components/Mobile/GrtLoading/GRTLoading';
import { getSearchStr } from '@/utils/Page';
const searchString = getSearchStr();
// ====================== 类型定义 ======================
interface RecordItem {
    document_id: string | number;
    document_name: string;
    data_type: string;
    realtime_status: number;
    key_words?: string[];
    type: number | string;
    thumbnail_url?: string;
    summarization?: string;
    duration?: any;
    complete_time?: any;
    ai_txt_status?: number;
    close_retry_tag?: number;
    [key: string]: any;
}

interface TransItem {
    document_id: string | number;
    document_name: string;
    type: number | string;
    ai_txt_status: number;
    close_retry_tag?: number;
    [key: string]: any;
}

interface UploadFileItem {
    key: string;
    name: string;
    fileName: string;
    status: 'normal' | 'active' | 'success' | 'exception';
    md5: string;
    uploadSize: number;
    totalSize: number;
    size: number;
    type: number;
    fingerprint: string;
    percent: number;
    fileUrl?: string;
    bucket?: string;
    ext_type?: string;
    obs_id?: string;
    default_url?: string;
    xhr?: XMLHttpRequest;
    [key: string]: any;
}

interface GrtAiStore {
    checkLogin: () => Promise<boolean>;
    checkCanUseStudy: (agentId: string | number) => Promise<any>;
    state?: {
        currentAgent?: {
            scene_tool?: Array<{ tool_id: string | number }>;
        };
    };
}

interface StoreProps {
    store: {
        grtAi: GrtAiStore;
    };
}

interface RouterParams {
    agentId: string | number;
    toolId: string | number;
}

interface MeetingPlatformProps extends StoreProps {
    params?: RouterParams;
    navigate?: (path: string) => void;
}

// ====================== 组件 ======================
const MeetingPlatform: React.FC<MeetingPlatformProps> = (props) => {
    const { grtAi } = props.store;
    const { agentId, toolId } = props?.params || {};
    const img = {
        search_icon: require('@/assets/images/tw/mobile/search_icon.webp'),
        searchCur_icon: require('@/assets/images/tw/mobile/searchCur_icon.webp'),
        progress_icon: require('@/assets/images/tw/mobile/progress_icon.webp'),
        progressIng_icon: require('@/assets/images/tw/mobile/progressIng_icon.webp'),
        progressError_icon: require('@/assets/images/tw/mobile/progressError_icon.webp'),
        sort_icon: require('@/assets/images/tw/mobile/sort_icon.webp'),
        sortDesc_icon: require('@/assets/images/tw/mobile/sortDesc_icon.webp'),
        sortAsc_icon: require('@/assets/images/tw/mobile/sortAsc_icon.webp'),
        sortAscNo_icon: require('@/assets/images/tw/mobile/sortAscNo_icon.webp'),
        filter_icon: require('@/assets/images/tw/mobile/filter_icon.webp'),
        filterCur_icon: require('@/assets/images/tw/mobile/filterCur_icon.webp'),
        recording_icon: require('@/assets/images/tw/mobile/recording_icon.webp'),
        upload_icon: require('@/assets/images/tw/mobile/upload_icon.webp'),
        more_icon: require('@/assets/images/tw/mobile/more_icon.webp'),
        delete_icon: require('@/assets/images/tw/mobile/delete_icon.webp'),
        addTitle_icon: require('@/assets/images/tw/mobile/addTitle_icon.webp'),
        video_icon: require('@/assets/images/tw/mobile/video_icon.webp'),
        videoCur_icon: require('@/assets/images/tw/mobile/videoCur_icon.webp'),
        audio_icon: require('@/assets/images/tw/mobile/audio_icon.webp'),
        audioCur_icon: require('@/assets/images/tw/mobile/audioCur_icon.webp'),
        record: require('@/assets/images/tw/mobile/record.webp'),
        uploadTip_icon: require('@/assets/images/tw/mobile/uploadTip_icon.webp'),
        uploadSm_icon: require('@/assets/images/tw/mobile/uploadSm_icon.webp'),
        placeholderImg: require('@/assets/images/tw/mobile/placeholderImg.webp')
    };
    const [isAddClick, setIsAddClick] = useState<boolean>(false);
    const [transList, setTransList] = useState<TransItem[]>([]);
    const [searchText, setSearchText] = useState<string>('');
    const [sortValue, setSortValue] = useState<string>('ctDesc');
    const [tempSortValue, setTempSortValue] = useState<string>(sortValue);
    const [hasSorted, setHasSorted] = useState<boolean>(false);
    const [hasFiltered, setHasFiltered] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    const [typeValue, setTypeValue] = useState<string>('0');
    const [languageValue, setLanguageValue] = useState<string>('');
    const [loadingUpload, setLoadingUpload] = useState<boolean>(false);
    const [form] = Form.useForm();
    const [sourceLanguageVal, setSourceLanguageVal] = useState<string>('cn');
    const [loadingBtn, setLoadingBtn] = useState<boolean>(false);
    const [isCheckCanUse, setIsCheckCanUse] = useState<boolean>(false);
    const [isToolTw, setIsToolTw] = useState<boolean>(false);
    const [retryLoading, setRetryLoading] = useState<Record<string, boolean>>({});

    const [visibleAdd, setVisibleAdd] = useState<boolean>(false);
    const [uploadList, setUploadList] = useState<UploadFileItem[]>([]);
    const [visibleUploadTip, setVisibleUploadTip] = useState<boolean>(false);
    const [visibleUpLoadMore, setVisibleUpLoadMore] = useState<boolean>(false);
    const [visibleTaskList, setVisibleTaskList] = useState<boolean>(false);
    const [visibleSort, setVisibleSort] = useState<boolean>(false);
    const [visibleFilter, setVisibleFilter] = useState<boolean>(false);
    const [visibleActions, setVisibleActions] = useState<boolean>(false);
    const [currentRecord, setCurrentRecord] = useState<RecordItem | null>(null);
    const [targetLanguagesVal, setTargetLanguagesVal] = useState<string>('no');
    const [speakerCountVal, setSpeakerCountVal] = useState<string>('1');
    const [visibleSearch, setVisibleSearch] = useState(false);
    const tenant_id = Storage.get('tenantId') || '';
    const fileListRef = useRef<UploadFileItem[]>([]);
    const listRef = useRef<any>(null);
    const listData = useRef<RecordItem[]>([]);
    const inputRef = useRef<any>(null);
    // 请求列表数据
    const request = async (params: any) => {
        const data = {
            ...params,
            key_words: searchText,
            sort_by: sortValue,
            type: typeValue,
            source_language: languageValue
        };
        const res: any = await handleGetTransInfoList(data);
        if (res && res.success) {
            if (params.page_num > 1) {
                listData.current = listData.current.concat(res.data);
            } else {
                listData.current = res.data;
            }
        }
        return { ...res, data: listData.current };
    };

    // 列表项渲染
    const renderItem = (record: RecordItem, index: number) => {
        return (
            <div className={s['list-box']} key={index} onClick={(e) => jumpInfo(record, e)}>
                <div className={s['list-top']}>
                    <h3 className={s['list-title']}>{record.document_name}</h3>
                    {record.data_type === 'realtime' && record.realtime_status === 1 ? null : (
                        <div
                            className={s['list-btn']}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setCurrentRecord(record);
                                setVisibleActions(true);
                            }}
                        >
                            <img src={img.more_icon} />
                        </div>
                    )}
                </div>

                {record.data_type === 'realtime' && record.realtime_status === 1 ? (
                    <div className={s['list-recording']}>
                        <img src={img.record} width={68} alt="录音" />
                        <div className={s['list-recording-text']}>
                            <span>正在录音中</span>
                            <span>停止录音后才能继续查看</span>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className={s['list-keyWords']}>
                            {record.key_words?.map((keyWords, idx) => (
                                <div key={idx}>{keyWords}</div>
                            ))}
                        </div>
                        <div className={s['list-type']} style={{ height: record.type === 2 || record.type === '2' ? '170px' : 'auto' }}>
                            {record.type === 2 || record.type === '2' ? (
                                <div
                                    className={s['listImg']}
                                    style={{
                                        background: record.thumbnail_url
                                            ? `url(${record.thumbnail_url}) no-repeat center`
                                            : `url(${img.placeholderImg}) no-repeat center`,
                                        backgroundSize: 'cover'
                                    }}
                                />
                            ) : (
                                <p>{record.summarization}</p>
                            )}
                        </div>
                    </>
                )}

                <div className={s['list-footer']}>
                    <div className={s['footer-lf']}>
                        {record.data_type === 'realtime' && record.realtime_status === 1 ? null : (
                            <>
                                {record.type === 2 ? <img src={img.videoCur_icon} /> : record.type === 3 ? <img src={img.audioCur_icon} /> : null}
                                {Utils.formatTime(record.duration)}
                            </>
                        )}
                    </div>
                    <div className={s['footer-rg']}>{formatDate(record.complete_time)}</div>
                </div>
                <div className={s['list-footer-line']}></div>
            </div>
        );
    };

    // 顶部添加按钮
    const handleAddHtml = () => {
        return (
            <div className={s['wrapperList-top']}>
                <span onClick={handleAddRecord}>
                    <img src={img.recording_icon} />
                    实时记录
                </span>
                <span onClick={handleAdd}>
                    <img src={img.upload_icon} />
                    上传音视频
                </span>
            </div>
        );
    };

    // 上传格式提示
    const renderUploadArea = () => {
        return (
            <div className={s['uploadItemTip']}>
                <div>
                    <i></i>单个文件最长6小时,单次最多可上传1个。
                </div>
                <div>
                    <i></i>视频支持:mp4/wmv/m4v/flv/rmvb/dat/mov/mkv/webm/
                    <br />
                    avi/mpeg/3gp/ogg，单个最大6G;
                </div>
                <div>
                    <i></i>音频支持:mp3/wav/m4a/wma/aac/ogg/amr/flac/aiff，单
                    <br />
                    个最大500M。
                </div>
            </div>
        );
    };

    // 上传列表项
    const uploadListHtml = (file: UploadFileItem, index: number) => {
        return (
            <div className={s['uploadList-list']} key={index}>
                <div className={s['list-title']}>
                    <div className={s['title']}>
                        <img
                            src={
                                file.type === 2
                                    ? file.status === 'success' && file.percent === 100
                                        ? img.videoCur_icon
                                        : img.video_icon
                                    : file.status === 'success' && file.percent === 100
                                      ? img.audioCur_icon
                                      : img.audio_icon
                            }
                        />
                        <span style={{ color: file.status === 'success' && file.percent === 100 ? '#333333' : '#999999' }}>{file.name}</span>
                    </div>
                    <img
                        className={s['transItem-del']}
                        onClick={(e) => {
                            e.stopPropagation();
                            confirmDelete(file);
                        }}
                        src={img.delete_icon}
                    />
                </div>
                <div className={s['list-status']}>
                    {file.status === 'active' || file.status === 'normal' ? (
                        <span style={{ color: '#333333', display: 'flex ' }}>正在上传</span>
                    ) : (file.status === 'success' && file.percent === 100) || !file.status ? (
                        <span style={{ color: '#07C160' }}>
                            {Utils.formatSize(file.totalSize)} <CheckOutline />
                        </span>
                    ) : file.status === 'exception' ? (
                        <span style={{ color: '#F23F33' }}>上传失败</span>
                    ) : null}
                </div>
            </div>
        );
    };

    // 登录跳转
    const goLogin = () => {
        const redirect = `${window.location.href}`;
        window.location.href = `${window.location.origin}/mobile/login?redirect=${redirect}`;
    };

    // 检查登录
    const checkIsLogin = async (): Promise<boolean> => {
        const res = await grtAi.checkLogin();
        if (res) return true;
        ToastUtils.showToast('请登录');
        setTimeout(() => goLogin(), 500);
        return false;
    };

    // 检查使用权限
    const checkCanUseFun = async () => {
        if (!agentId) return;
        const res = await grtAi.checkCanUseStudy(agentId);
        if (!res || !res.success || !res.data) {
            ToastUtils.showToast('该智能体未对外开放使用，请联系管理员');
            setIsCheckCanUse(true);
        }
    };

    // 打开上传弹窗
    const handleAdd = () => {
        setUploadList([]);
        setVisibleAdd(true);
        setIsAddClick(false);
    };

    // 实时记录
    const handleAddRecord = () => {
        fetchCheckCanRecord().then((res: any) => {
            if (res.success && res.data) {
                return ToastUtils.showToast('已经有一个实时录音未停止，请稍等～');
            }
            if (agentId && toolId && props.navigate) {
                props.navigate(`/mobile/o/${agentId}/tools/${toolId}/add/record${searchString}`);
            }
        });
    };

    // 取消上传
    const onCancelAdd = () => {
        setUploadList([]);
        setVisibleAdd(false);
        setSourceLanguageVal('cn');
        setTargetLanguagesVal('no');
        setSpeakerCountVal('1');
        handleGetTransListFun();
        handleGetTransInfoListFun();
    };

    // 获取转写任务列表
    const handleGetTransListFun = async (isAddClick?: boolean) => {
        const res: any = await handleGetTransList();
        if (res?.success) {
            setTransList(res.data);
            if (res.data?.length > 0) setIsAddClick(true);
            if (isAddClick) setVisibleTaskList(true);
        } else {
            ToastUtils.showToast(res?.msg || '操作失败');
        }
    };

    // 获取记录列表
    const handleGetTransInfoListFun = async () => {
        setLoading(true);
        const data = { page: 1, page_size: 10 };
        const res: any = await handleGetTransInfoList(data);
        if (res?.success) {
            if (res.data?.length > 0) setIsAddClick(true);
        } else {
            ToastUtils.showToast(res?.msg || '操作失败');
        }
        setLoading(false);
    };

    // 重试转写
    const handleRetryTransFun = async (ele: TransItem) => {
        setRetryLoading((prev) => ({ ...prev, [ele.document_id]: true }));
        const res: any = await handleRetryTrans(ele.document_id);
        if (res?.success) {
            handleGetTransListFun();
        } else {
            ToastUtils.showToast(res?.msg || '操作失败');
        }
        setRetryLoading((prev) => ({ ...prev, [ele.document_id]: false }));
    };

    // 创建转写任务
    const handleCreateFun = async (data: any) => {
        if (!agentId || !toolId) return;
        const res: any = await handleCreate(data, agentId, toolId);
        if (res?.success) {
            setLoadingBtn(false);
            setIsAddClick(true);
            setVisibleAdd(false);
            handleGetTransListFun(true);
            setUploadList([]);
            setSourceLanguageVal('cn');
            setTargetLanguagesVal('no');
            setSpeakerCountVal('1');
            fileListRef.current = [];
        } else {
            ToastUtils.showToast(res?.msg || '查询失败');
            setLoadingBtn(false);
        }
    };

    // 源语言切换
    const sourceLanguageOn = (e: { target: { value: string } }) => {
        setSourceLanguageVal(e.target.value);
        form.setFieldsValue({ target_languages: ['no'] });
    };

    // 提交上传
    const handleUpload = () => {
        form.validateFields()
            .then((res) => {
                const uploadingFiles = uploadList.filter((f) => f.status === 'active' && f.percent !== 100);
                if (uploadingFiles.length) {
                    ToastUtils.showToast('有文件在上传中，请稍等提交');
                    return;
                }
                if (!uploadList.length) {
                    ToastUtils.showToast('请选择上传的文件');
                    return;
                }

                res.source_language = sourceLanguageVal;
                res.target_languages = targetLanguagesVal;
                res.speaker_count = Number(speakerCountVal);

                const validFiles = uploadList.filter((f) => !(f.status === 'exception' && f.percent !== 100));
                const uploadData = validFiles.map((file) => ({ document_dto: { ...file }, ...res }));

                setLoadingBtn(true);
                handleCreateFun(uploadData);
            })
            .catch((err) => console.error(err));
    };

    // 搜索
    const handleSearch = (value: string) => setSearchText(value);
    const handleSearchClick = () => listRef.current?.refresh();
    const handleCancelSearch = () => {
        setVisibleSearch(false);
        listRef.current?.refresh();
        setSearchText('');
    };
    // 排序
    const handleSort = (field: string) => {
        setSortValue(field);
        listRef.current?.refresh();
    };

    // 删除
    const handleDeleteFun = async (ids: (string | number)[], type?: number) => {
        const res: any = await handleDelete({ document_ids: ids });
        if (res?.success) {
            ToastUtils.showToast('删除成功');
            if (type === 1) {
                handleGetTransListFun();
            } else {
                listRef.current?.refresh();
            }
        } else {
            ToastUtils.showToast(res?.msg || '操作失败');
        }
    };

    // 单个删除
    const handleSingleDelete = (ele: RecordItem | TransItem, type?: number) => {
        if (type === 1) {
            handleDeleteFun([ele.document_id], type);
            return;
        }
        Dialog.confirm({
            bodyClassName: s['modal-popup-dialog'],
            content: <div style={{ color: '#333', fontSize: 16, textAlign: 'center', padding: '12px 0', fontWeight: 400 }}>确定删除本记录吗?</div>,
            confirmText: '确定',
            cancelText: '取消',
            onConfirm: () => handleDeleteFun([ele.document_id])
        });
    };

    // 重命名
    const handleTitleRenaming = (ele: RecordItem) => {
        setCurrentRecord(ele);
        let localTitle = ele.document_name;
        let errorEl: HTMLDivElement | null = null;

        // 创建独立的重命名对话框组件
        const RenameDialog = () => {
            const [visible, setVisible] = useState(true);
            const [loading, setLoading] = useState(false);

            const handleOk = async () => {
                if (!localTitle?.trim()) {
                    if (errorEl) {
                        errorEl.style.display = 'block';
                    }
                    return;
                }

                setLoading(true);
                try {
                    const res: any = await handleUpdateTitle(ele.document_id, { document_name: localTitle });
                    if (res?.success) {
                        listRef.current?.refresh();
                        setVisible(false);
                    } else {
                        ToastUtils.showToast(res?.msg || '操作失败');
                    }
                } catch (error) {
                    ToastUtils.showToast('操作失败');
                } finally {
                    setLoading(false);
                }
            };

            const renderContent = () => (
                <div>
                    <div style={{ padding: '8px', background: '#F6F6F6', borderRadius: '3px' }}>
                        <TextArea
                            onChange={(val) => {
                                localTitle = val;
                                if (errorEl) {
                                    errorEl.style.display = 'none';
                                }
                            }}
                            placeholder="请输入标题"
                            maxLength={50}
                            rows={2}
                            showCount
                            defaultValue={localTitle}
                            style={{ '--font-size': '12px', '--color': '#313131' }}
                        />
                    </div>
                    <div ref={(el) => (errorEl = el)} style={{ color: '#FF0909', fontSize: 12, marginTop: 5, display: 'none', textAlign: 'right' }}>
                        请输入标题
                    </div>
                    <div className={`${s['btnDialog-css']}`}>
                        <Button size="small" onClick={() => setVisible(false)} className={s['btn-reset']}>
                            取消
                        </Button>
                        <Button size="small" color="primary" className={s['btn-primary']} loading={loading} onClick={handleOk} disabled={loading}>
                            确定
                        </Button>
                    </div>
                </div>
            );

            return (
                <Dialog
                    visible={visible}
                    bodyClassName={s['modal-popup-renderContent']}
                    title="重命名"
                    content={renderContent()}
                    closeOnAction={false}
                    onClose={() => setVisible(false)}
                />
            );
        };

        // 渲染对话框
        const container = document.createElement('div');
        document.body.appendChild(container);
        const root = createRoot(container);

        const DialogWrapper = () => {
            const [mounted] = useState(true);

            if (!mounted) {
                root.unmount();
                document.body.removeChild(container);
                return null;
            }

            return <RenameDialog />;
        };

        root.render(<DialogWrapper />);
    };

    // 跳转详情
    const jumpInfo = (ele: RecordItem, e: React.MouseEvent) => {
        if (ele.data_type === 'realtime' && ele.realtime_status === 1) return;
        e.stopPropagation();
        if (agentId && toolId && props.navigate) {
            props.navigate(`/mobile/o/${agentId}/tools/${toolId}/${ele.document_id}${searchString}`);
        }
    };

    // 上传校验
    const validFileList = () => {
        if (!uploadList.length) return Promise.reject('请选择上传的文件');
        return Promise.resolve();
    };

    // 获取文件后缀
    const getFileExtAndName = (fileName: string) => {
        const index = fileName.lastIndexOf('.');
        const ext = fileName.substring(index + 1);
        const name = fileName.substring(0, index);
        return { fileExt: ext, fileName: name };
    };

    // 文件校验
    const fileChange = (file: any) => {
        setLoadingUpload(true);
        const maxSize = 6 * 1024 * 1024 * 1024;
        if (file.size > maxSize) {
            ToastUtils.showToast('文件大小超出限制');
            setLoadingUpload(false);
            return false;
        }
        return true;
    };

    // 上传错误
    const uploadFileErrorHandle = (error: any, file: any, obsResult: any) => {
        if (error.message === '文件格式不支持') {
            ToastUtils.showToast('文件非可处理文件，建议上传支持的音视频文件');
        } else {
            setUploadList((prevList) => {
                const newList = cloneDeep(prevList);
                newList.forEach((item) => {
                    if (item.fileName === obsResult.objectKey) {
                        item.status = 'exception';
                    }
                });
                return newList;
            });
        }
        setLoadingUpload(false);
    };

    // 本地上传完成
    const completeItemUpload = async (result: any) => {
        setUploadList((prevList) => {
            const newList = cloneDeep(prevList);
            newList.forEach((item) => {
                if (item.fileName === result.objectKey) {
                    const { fileExt, fileName } = getFileExtAndName(item.name);
                    item.type = getCourseEditingUploadType(item.type);
                    item.open = getPrivateOrPublic(item.type);
                    item.bucket = result.bucketName;
                    item.name = fileName.substring(0, 50);
                    item.ext_type = fileExt;
                    item.obs_id = item.fileName;
                    item.default_url = result.fileUrl;
                    item.percent = 100;
                    item.status = 'success';
                }
            });
            fileListRef.current = newList;
            return newList;
        });
    };

    // 本地进度
    const updateProcess = (process: number, file: any, xhr: XMLHttpRequest, obsResult: any) => {
        setUploadList((prevList) => {
            const newList = cloneDeep(prevList);
            newList.forEach((item) => {
                if (item.fileName === obsResult.objectKey) {
                    item.status = 'active';
                    item.percent = Math.floor(process * 100);
                    item.uploadSize = process * file.size;
                    item.md5 = obsResult.md5;
                    item.xhr = xhr;
                }
            });
            return newList;
        });
    };

    // 上传前校验
    const beforeUploadHandle = async (file: any, name: string, md5: string, fileType: UploadType) => {
        if (fileType === UploadType.UNSET) {
            ToastUtils.showToast('文件非可处理文件');
            setLoadingUpload(false);
            return false;
        }
        const exists = uploadList.some((i) => i.fileName === name && i.status !== 'exception');
        if (exists) {
            ToastUtils.showToast('文件已存在');
            setLoadingUpload(false);
            return false;
        }
        if (fileListRef.current.length >= 10) {
            ToastUtils.showToast('最多上传10个文件');
            setLoadingUpload(false);
            return false;
        }

        const newItem: UploadFileItem = {
            key: name,
            name: file.name,
            fileName: name,
            status: 'normal',
            md5,
            uploadSize: 0,
            totalSize: file.size,
            size: file.size,
            type: fileType,
            fingerprint: md5,
            percent: 0
        };

        const updatedList = [...uploadList, newItem];
        setUploadList(updatedList);
        fileListRef.current = updatedList;
        setLoadingUpload(false);
        return true;
    };

    // 删除上传文件
    const confirmDelete = (data: UploadFileItem) => {
        setUploadList((prevList) => {
            const newList = prevList.filter((item) => item.name !== data.name);
            fileListRef.current = newList;

            // 如果删除后列表为空，关闭更多列表弹窗
            if (newList.length === 0) {
                setVisibleUpLoadMore(false);
            }

            return newList;
        });
    };

    // 初始化
    useEffect(() => {
        const toolData = grtAi?.state?.currentAgent?.scene_tool;
        if (toolData && toolData.length > 0) {
            const exists = toolData.some((tool) => tool.tool_id === 1 || tool.tool_id === '1');

            if (!exists) {
                ToastUtils.showToast('该智能体未对外开放使用，请联系管理员');
                return setIsToolTw(true);
            }
            setIsToolTw(false);
        } else {
            setIsToolTw(true);
            ToastUtils.showToast('该智能体未对外开放使用，请联系管理员');
        }

        handleGetTransListFun();
        handleGetTransInfoListFun();
        checkIsLogin();
        checkCanUseFun();
    }, []);

    // 表单初始化
    useEffect(() => {
        if (form && visibleAdd) {
            form.setFieldsValue({
                speaker_count: '1',
                source_language: 'cn',
                target_languages: 'no'
            });
        }
    }, [form, visibleAdd]);

    return (
        <div className={s['wrapper']}>
            <Display show={isCheckCanUse || isToolTw}>
                <div className={s['isCheckCanUse']}></div>
            </Display>
            {loading ? (
                <div className={s['loading-container']}>
                    <GrtLoading></GrtLoading>
                </div>
            ) : (
                <>
                    <Display show={!isAddClick && !visibleAdd}>
                        <div className={s['wrapperAdd-item']}>
                            <div className={s['wrapperAdd-item-content']}>
                                <div className={s['wrapperAdd-item-content-itemRecord']} onClick={handleAddRecord}>
                                    <span>实时记录</span>
                                </div>
                                <div className={s['wrapperAdd-item-content-itemUpload']} onClick={handleAdd}>
                                    <span>上传音视频</span>
                                </div>
                            </div>
                        </div>
                    </Display>

                    <Display show={isAddClick}>
                        {handleAddHtml()}
                        <div className={s['wrapper-index']}>
                            <div className={s['top-search']}>
                                <div className={s['search-lf']}>
                                    <span>我的记录</span>
                                    <Display show={!visibleSearch}>
                                        <img
                                            src={img.search_icon}
                                            onClick={() => {
                                                setVisibleSearch(true);
                                                setTimeout(() => {
                                                    inputRef.current?.focus();
                                                }, 100);
                                            }}
                                        />
                                    </Display>
                                    <Display show={visibleSearch}>
                                        <div className={s['searchInput']}>
                                            <div className={s['searchInput-content']}>
                                                <img src={img.searchCur_icon} onClick={handleSearchClick} />
                                                <Input
                                                    ref={inputRef}
                                                    onEnterPress={handleSearchClick}
                                                    maxLength={50}
                                                    onChange={handleSearch}
                                                    value={searchText}
                                                    clearable={true}
                                                    onClear={() => {
                                                        setSearchText('');
                                                        setTimeout(() => {
                                                            inputRef.current?.focus();
                                                        }, 100);
                                                    }}
                                                />
                                            </div>
                                            <span className={s['searchCancel']} onClick={() => handleCancelSearch()}>
                                                取消
                                            </span>
                                        </div>
                                    </Display>
                                </div>

                                <Display show={!visibleSearch}>
                                    <div className={s['search-rg']}>
                                        <div
                                            className={s['transList']}
                                            onClick={() => {
                                                handleGetTransListFun();
                                                setVisibleTaskList(true);
                                            }}
                                        >
                                            <Display show={transList.length > 0}>
                                                {transList.every((item) => item.ai_txt_status === 1) ? (
                                                    <img src={img.progressIng_icon} />
                                                ) : (
                                                    <img src={img.progressError_icon} />
                                                )}
                                            </Display>
                                            <Display show={transList.length === 0}>
                                                <img src={img.progress_icon} />
                                            </Display>
                                        </div>

                                        <div
                                            onClick={() => {
                                                setTempSortValue(sortValue);
                                                setVisibleSort(true);
                                            }}
                                        >
                                            {hasSorted ? (
                                                sortValue === 'ctDesc' ? (
                                                    <img src={img.sortDesc_icon} />
                                                ) : sortValue === 'ctAsc' ? (
                                                    <img src={img.sortAsc_icon} />
                                                ) : (
                                                    <img src={img.sort_icon} />
                                                )
                                            ) : (
                                                <img src={img.sort_icon} />
                                            )}
                                        </div>
                                        <div onClick={() => setVisibleFilter(true)}>
                                            {hasFiltered ? <img src={img.filterCur_icon} /> : <img src={img.filter_icon} />}
                                        </div>
                                    </div>
                                </Display>
                            </div>

                            <div className={s['item-list']}>
                                <div className={s['list-line']}> </div>
                                <div className={s['list-wrap']} id="list">
                                    <PullRefreshList ref={listRef} renderItem={renderItem} scrollableTarget="list" request={request} />
                                </div>
                            </div>
                            <div className={s['list-line']}> </div>
                        </div>
                    </Display>
                </>
            )}

            {/* 上传弹窗 */}
            <Display show={visibleAdd}>
                <div className={s['form-wrapper']}>
                    <div className={s['upload-top']}>
                        <div className={s['uploadTitle']} onClick={() => onCancelAdd()}>
                            <LeftOutline />
                            <span>上传音视频</span>
                        </div>
                        {uploadList.length > 0 && (
                            <div className={s['uploadTip']} onClick={() => setVisibleUploadTip(true)}>
                                <img src={img.uploadTip_icon} />
                            </div>
                        )}
                    </div>

                    <Form
                        layout="vertical"
                        form={form}
                        initialValues={{
                            source_language: [sourceLanguageOptions[0]?.value || 'cn'],
                            target_languages: ['no'],
                            speaker_count: [speakerOptions[0]?.value || '1']
                        }}
                    >
                        <div className={s['addForm-wrapper']}>
                            <div className={s['addForm-top']}>
                                <Form.Item name="document" rules={[{ required: true, validator: validFileList }]}>
                                    <ServiceUpload
                                        multiple={false}
                                        dirname={tenant_id}
                                        onChange={fileChange}
                                        errorFunc={uploadFileErrorHandle}
                                        completeFunc={completeItemUpload}
                                        processFunc={updateProcess}
                                        beforeUpload={beforeUploadHandle}
                                        maxSize={6 * 1024 * 1024 * 1024}
                                        maxSizeAudio={500 * 1024 * 1024}
                                        uploadItem={
                                            <div className={s['uploadItem']}>
                                                {loadingUpload ? (
                                                    <div className={s['uploadItem-loading']}>
                                                        <SpinLoading />
                                                    </div>
                                                ) : null}
                                                {uploadList.length > 0 ? (
                                                    <div className={s['uploadItemSm-box']}>
                                                        <img src={img.uploadSm_icon} />
                                                        <span>点击上传音视频文件到这里</span>
                                                    </div>
                                                ) : (
                                                    <div className={s['uploadItem-box']}>
                                                        <img src={img.upload_icon} />
                                                        <span>点击上传音视频文件到这里</span>
                                                    </div>
                                                )}

                                                {uploadList.length === 0 && renderUploadArea()}
                                            </div>
                                        }
                                    />
                                    {uploadList?.length > 0 && (
                                        <div>
                                            <div style={{ height: '16px' }}></div>

                                            <div className={s['uploadList-item']}>
                                                <div style={{ paddingBottom: uploadList?.length > 3 ? '25px' : '' }}>
                                                    {uploadList.map((file, idx) => uploadListHtml(file, idx))}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {uploadList?.length > 3 && (
                                        <div className={s['uploadItem-more']} onClick={() => setVisibleUpLoadMore(true)}>
                                            查看上传列表
                                        </div>
                                    )}
                                </Form.Item>
                            </div>

                            <div className={s['addForm-bottom']}>
                                <Form.Item name="source_language">
                                    <div className={s['selector-item-title']}>
                                        <img src={img.addTitle_icon} />
                                        选择音视频语言
                                    </div>
                                    <div className={s['selector-lsit']}>
                                        <Selector
                                            showCheckMark={false}
                                            options={sourceLanguageOptions}
                                            value={[sourceLanguageVal]}
                                            onChange={(vals) => {
                                                if (vals.length) {
                                                    setSourceLanguageVal(vals[0]);
                                                    sourceLanguageOn({ target: { value: vals[0] } });
                                                }
                                            }}
                                        />
                                    </div>
                                </Form.Item>

                                <Form.Item name="target_languages">
                                    <div className={s['selector-item-title']}>
                                        <img src={img.addTitle_icon} />
                                        翻译
                                    </div>
                                    <div className={s['selector-lsit']}>
                                        <Selector
                                            showCheckMark={false}
                                            options={(function () {
                                                const base = [{ label: '不翻译', value: 'no' }];
                                                switch (sourceLanguageVal) {
                                                    case 'en':
                                                        return [...base, { label: '中文', value: 'cn' }, { label: '日语', value: 'ja' }];
                                                    case 'cn':
                                                        return [...base, { label: '英语', value: 'en' }, { label: '日语', value: 'ja' }];
                                                    case 'ja':
                                                        return [...base, { label: '中文', value: 'cn' }, { label: '英语', value: 'en' }];
                                                    default:
                                                        return base;
                                                }
                                            })()}
                                            disabled={sourceLanguageVal === 'yue' || sourceLanguageVal === 'fspk'}
                                            value={[targetLanguagesVal]}
                                            onChange={(v) => {
                                                if (v.length) {
                                                    setTargetLanguagesVal(v[0]);
                                                    form.setFieldsValue({ target_languages: v });
                                                }
                                            }}
                                        />
                                    </div>
                                </Form.Item>

                                <Form.Item name="speaker_count">
                                    <div className={s['selector-item-title']}>
                                        <img src={img.addTitle_icon} />
                                        区分发言人
                                    </div>
                                    <div className={s['selector-lsit']}>
                                        <Selector
                                            showCheckMark={false}
                                            options={speakerOptions}
                                            value={[speakerCountVal]}
                                            onChange={(v) => {
                                                if (v.length) {
                                                    setSpeakerCountVal(v[0]);
                                                    form.setFieldsValue({ speaker_count: v });
                                                }
                                            }}
                                        />
                                    </div>
                                </Form.Item>
                            </div>
                        </div>
                        <div className={`${s['btn-css']} ${s['btn-css-bottom']}`}>
                            <Button size="small" color="primary" className={s['btn-reset']} onClick={onCancelAdd}>
                                取消
                            </Button>
                            <Button
                                size="small"
                                color="primary"
                                className={s['btn-primary']}
                                type="reset"
                                onClick={handleUpload}
                                disabled={!uploadList.length}
                                loading={loadingBtn}
                            >
                                开始转写
                            </Button>
                        </div>
                    </Form>
                </div>
            </Display>

            {/* 任务列表 */}
            <ModalPopup visible={visibleTaskList} title="任务列表" onClose={() => setVisibleTaskList(false)}>
                <Display show={transList.length > 0}>
                    <div className={s['transList-content']}>
                        {transList.map((record, idx) => (
                            <div className={s['transItem']} key={idx}>
                                <div className={s['transItem-title']}>
                                    <p>
                                        <img src={record.type === 2 ? img.video_icon : img.audio_icon} />
                                        <span>{record.document_name}</span>
                                    </p>
                                    <img className={s['transItem-del']} onClick={() => handleSingleDelete(record, 1)} src={img.delete_icon} />
                                </div>
                                {record.ai_txt_status === 1 ? (
                                    <div className={s['transItem-ing']}>转写中</div>
                                ) : (
                                    <div className={s['transItem-fail']}>
                                        <span>转写失败</span>
                                        {record.close_retry_tag !== 1 && (
                                            <Button
                                                className={s['transItem-retry']}
                                                loading={retryLoading[record.document_id] || false}
                                                onClick={() => handleRetryTransFun(record)}
                                            >
                                                重新转写
                                            </Button>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </Display>
                <Display show={transList.length === 0}>
                    <div className={s['status-div']} style={{ padding: '40px 0 60px' }}>
                        <img src={emptyImg} style={{ marginTop: '0' }} />
                        <div className={s['status-text']}>暂无转写任务</div>
                    </div>
                </Display>
            </ModalPopup>

            {/* 排序 */}
            <ModalPopup visible={visibleSort} title="排序" onClose={() => setVisibleSort(false)}>
                {/* 自定义排序选择器 */}
                <div>
                    <div className={s['sortList']}>
                        {[
                            { label: '创建时间降序', value: 'ctDesc', icon: img.sort_icon, iconCur: img.sortDesc_icon },
                            { label: '创建时间升序', value: 'ctAsc', icon: img.sortAscNo_icon, iconCur: img.sortAsc_icon }
                        ].map((option) => (
                            <div key={option.value} className={s['sortItem']} onClick={() => setTempSortValue(option.value)}>
                                <div className={s['sortItem-content']} style={tempSortValue === option.value ? { color: '#3B70FF' } : {}}>
                                    <img src={tempSortValue === option.value ? option.iconCur : option.icon} />
                                    {option.label}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className={s['btn-css']}>
                        <Button
                            size="small"
                            color="primary"
                            className={s['btn-reset']}
                            onClick={() => {
                                setSortValue('ctDesc');
                                setTempSortValue('ctDesc');
                                handleSort('ctDesc');
                                setVisibleSort(false);
                                setHasSorted(false);
                            }}
                        >
                            重置
                        </Button>
                        <Button
                            size="small"
                            color="primary"
                            className={s['btn-primary']}
                            onClick={() => {
                                setSortValue(tempSortValue);
                                handleSort(tempSortValue);
                                setVisibleSort(false);
                                setHasSorted(true);
                            }}
                        >
                            确定
                        </Button>
                    </div>
                </div>
            </ModalPopup>

            {/* 筛选 */}
            <ModalPopup visible={visibleFilter} title="筛选" onClose={() => setVisibleFilter(false)}>
                <div>
                    <div className={s['selector-item']}>
                        <div className={s['selector-item-title']}>
                            <img src={img.addTitle_icon} />
                            转写语言
                        </div>
                        <div className={s['selector-lsit']}>
                            <Selector
                                showCheckMark={false}
                                value={[languageValue]}
                                onChange={(val) => val.length && setLanguageValue(val[0])}
                                options={languageOptionsSearch}
                            />
                        </div>
                    </div>
                    <div className={s['selector-item']}>
                        <div className={s['selector-item-title']}>
                            <img src={img.addTitle_icon} />
                            音视频
                        </div>
                        <div className={s['selector-lsit']}>
                            <Selector
                                showCheckMark={false}
                                columns={4}
                                value={[typeValue]}
                                onChange={(val) => val.length && setTypeValue(val[0])}
                                options={[
                                    { label: '全部', value: '0' },
                                    { label: '音频', value: '3' },
                                    { label: '视频', value: '2' }
                                ]}
                            />
                        </div>
                    </div>
                    <div className={s['btn-css']}>
                        <Button
                            size="small"
                            color="primary"
                            className={s['btn-reset']}
                            onClick={() => {
                                setTypeValue('0');
                                setLanguageValue('');
                                setHasFiltered(false);
                                listRef.current?.refresh();
                                setVisibleFilter(false);
                            }}
                        >
                            重置
                        </Button>
                        <Button
                            size="small"
                            color="primary"
                            className={s['btn-primary']}
                            onClick={() => {
                                setHasFiltered(languageValue !== '' || typeValue !== '0');
                                listRef.current?.refresh();
                                setVisibleFilter(false);
                            }}
                        >
                            确定
                        </Button>
                    </div>
                </div>
            </ModalPopup>

            {/* 操作菜单 */}
            <ModalPopup visible={visibleActions} title={currentRecord?.document_name || ''} onClose={() => setVisibleActions(false)} height={150}>
                <div className={s['modal-popup-actions']}>
                    <div
                        className={s['modal-actions-item']}
                        onClick={() => {
                            handleTitleRenaming(currentRecord!);
                            setVisibleActions(false);
                        }}
                    >
                        重命名
                    </div>
                    <div
                        className={s['modal-actions-item']}
                        onClick={() => {
                            handleSingleDelete(currentRecord!);
                            setVisibleActions(false);
                        }}
                    >
                        删除
                    </div>
                </div>
            </ModalPopup>

            {/* 上传提示 */}
            <ModalPopup visible={visibleUploadTip} title="支持格式" onClose={() => setVisibleUploadTip(false)}>
                <div className={s['uploadTipPop-wrapper']}>{renderUploadArea()}</div>
            </ModalPopup>

            {/* 上传列表 */}
            <ModalPopup visible={visibleUpLoadMore} title="上传列表" onClose={() => setVisibleUpLoadMore(false)}>
                <div className={s['uploadList-wrapper']}>{uploadList.map((file, idx) => uploadListHtml(file, idx))}</div>
            </ModalPopup>
        </div>
    );
};

export default withRouter(inject('store')(observer(MeetingPlatform)));
